export default {
  "cat.shoes": "Zapatos",
  "cat.hoodies": "Sudaderas / Suéteres",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones / Shorts",
  "cat.headwear": "Gorros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior",
  "cat.jersey": "Camisetas deportivas",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otros artículos",
};